export type CheckInAfterSubmitNavigation = {
  /** When set, navigate here (may coincide with advancing step). */
  nextRoute: string | null;
  /** When true, move the wizard from duration → cause. */
  advanceToCauseStep: boolean;
};

/**
 * Mirrors the historical CheckInAdd order: existing-record and offline paths first,
 * then cause-step home, then duration → cause.
 */
export function computeCheckInAfterSubmitNavigation({
  existingRecord,
  isOffline,
  step,
}: {
  existingRecord: unknown;
  isOffline: boolean;
  step: string;
}): CheckInAfterSubmitNavigation {
  let nextRoute: string | null = null;
  let advanceToCauseStep = false;

  if (existingRecord) {
    nextRoute = "/app/home";
  }
  if (isOffline) {
    nextRoute = "/app/home";
    return { nextRoute, advanceToCauseStep: false };
  }
  if (step === "cause") {
    nextRoute = "/app/home";
  }

  return { nextRoute, advanceToCauseStep };
}

export type CheckInSubmitResult = {
  ok: boolean;
  mode?: string;
  entry?: unknown;
  navigation: CheckInAfterSubmitNavigation;
};
